module.exports = __webpack_public_path__ + "static/media/Spanish-imperative.7f21682a.jpg";